<template>
  <van-tabs class="deatailParam" v-model:active="active" :scrollspy="true" :sticky="true" offset-top="80px">
    <van-tab title="规格参数">
      <Divider class="divider" text="规格参数" size="12" imgWidth="39%" />
      <div class="keyVal">
        <KeyVal :datas="params" />
      </div>
    </van-tab>
    <van-tab title="产品详情">
      <div>
        <img :src="tyreD1Src" />
      </div>
    </van-tab>
    <van-tab title="购买流程">
      <div>
        <img class="tyreD2" :src="tyreD2Src" />
      </div>
    </van-tab>
  </van-tabs>
</template>

<script>
import { reactive, toRefs, onMounted, computed } from 'vue'
import Divider from '@/components/common/Divider'
import KeyVal from '@/components/common/KeyVal'
import { useStore } from 'vuex'
export default {
  components: {
    Divider,
    KeyVal
  },
  props: ['datas'],
  setup(props) {
    let { datas } = toRefs(props)
    let store = useStore()
    const state = reactive({
      domain: store.state.staticDomain,
      active: 0,
      sticky: {
        scrollTop: '80px',
        isFixed: true
      },
      datas,
      params: '',
      // nonce: Date.now()
      nonce: 1
    })
    const tyreD1Src = computed(() => `${state.domain}/mp/staticimg/tyreD1.png?nonce=${state.nonce}`)
    const tyreD2Src = computed(() => `${state.domain}/mp/staticimg/tyreD2.png?nonce=${state.nonce}`)
    onMounted(() => {
      let meoText = {
        MO: 'Mercedes Original，梅赛德斯-奔驰原⼚认证轮胎',
        MOE: 'Mercedes Original Extended，<br>梅赛德斯-奔驰原⼚认证低压续航轮胎',
        MO1: '⾼性能梅赛德斯-奔驰原⼚认证轮胎',
        MOS: '静⾳梅赛德斯-奔驰原⼚认证轮胎'
      }
      let { brand, habitat, spec, speed_rating, load_index, moe, models, pattern } = state.datas
      state.params = [
        { name: '品牌', value: `${brand.name || ''} / ${brand.code || ''}` },
        { name: '产地', value: habitat || '' },
        { name: '轮胎规格', value: spec || '' },
        { name: '速度级别', value: speed_rating || '' },
        { name: '载重指数', value: load_index || '' },
        { name: '原厂标识', value: moe ? `${moe} (${meoText[moe]})` : '' },
        { name: '花纹', value: pattern || '' },
        {
          name: '适配车型',
          value: models || ''
        }
      ]
    })
    return {
      ...toRefs(state),
      tyreD1Src,
      tyreD2Src
    }
  }
}
</script>

<style lang="scss" scoped>
.divider,
.deatailParam {
  background: #ffffff;
}
.keyVal {
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
}
:deep(.van-col) {
  max-height: 100px;
}
.tabpanel {
  // overflow: auto;
}
img {
  width: 100%;
}
:deep(.van-tabs__line) {
  width: 98px;
  background-color: #3088c5;
}
:deep(.van-tab--active) {
  color: #3088c5;
  font-size: 14px;
  font-weight: 600;
}
.tyreD2 {
  margin-bottom: 80px;
}
</style>
